import {paramStore} from "../../../../../../stores";

export const tableScroll$ = paramStore('s');
